/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageContent } from './messageContent';


export interface Message { 
    /**
     * List of Message Content
     */
    content?: Array<MessageContent>;
    /**
     * To include firstName of recipient in the message
     */
    personalise?: boolean;
}

